import { render, staticRenderFns } from "./_chapter.vue?vue&type=template&id=136fc180&"
import script from "./_chapter.vue?vue&type=script&lang=js&"
export * from "./_chapter.vue?vue&type=script&lang=js&"
import style0 from "./_chapter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "_chapter.vue"
export default component.exports